import React, { Component } from 'react';
import $ from 'jquery';
import Button from 'components/ui/button/Button';

type Props = {
  context: {
    dispatch: (action: any) => void;
    showModal?: boolean;
    modalContent: string;
    modalTitle: string;
  };
};

export default class ModalComplete extends Component<Props> {
  dispatch: (action: any) => void;

  constructor(props: Props) {
    super(props);

    this.dispatch = props.context.dispatch;
  }

  closeModal = (): void => {
    this.dispatch({
      type: 'SHOW_MODAL',
      showModal: false,
      modalTitle: null,
      modalContent: null,
      buttons: false,
    });
  };

  componentWillUnmount = (): void => {
    $('#ModalComplete').modal('hide');
  };

  render = (): JSX.Element => {
    const {
      context: { showModal, modalContent, modalTitle },
    } = this.props;
    if (showModal) {
      $('#ModalComplete').modal('show');
    } else {
      $('#ModalComplete').modal('hide');
    }

    return (
      <div
        className="modal fade"
        id="ModalComplete"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="ModalCenter"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="ModalCenter">
                {modalTitle}
              </h5>
            </div>
            <div className="modal-body">{modalContent}</div>
            <div className="modal-footer">
              <Button className="btn-orange" onClick={this.closeModal}>
                <span>Entendi</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  };
}
